import * as actions from "./Type";
import Instance from "../util/Instance";
import setToken from "../util/SetToken";
import "react-toastify/dist/ReactToastify.css";

export const Get_List_Rent_Property = (aid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/PropertysOFAgentRent/${aid}`,
        config
      );
      dispatch({
        type: actions.GET_LIST_PROPERTY_RENT,
        payload: res.data.data,
      });
    } catch (error) {
      alert("can not get any Rent Propertys  ");
    }
  };
};
export const Get_List_Sell_Property = (aid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/PropertysOFAgentSell/${aid}`,
        config
      );
      dispatch({
        type: actions.GET_LIST_PROPERTY_SELL,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const View_Detail_Each_Sell = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAvailableProperty/${id}`,
        config
      );
      dispatch({
        type: actions.VIEW_DETAIL_SELL,
        payload: res.data.data,
      });
    } catch (error) {
      alert("can not get any View Detail of Each Sell");
    }
  };
};
export const View_Detail_Each_Rent = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAvailableProperty/${id}`,
        config
      );
      dispatch({
        type: actions.VIEW_DETAIL_RENT,
        payload: res.data.data,
      });
    } catch (error) {
      alert("can not get any View Detail of Each Rent");
    }
  };
};
export const Property_Status = (id, status) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/updateAvailablePropertyStatus/${id}?status=${status}`,
        config
      );
      dispatch({ type: actions.UPDATEING_PROPERTY_STATUS });
    } catch (error) {}
  };
};
export const Delete_Property = (propertyId) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/delteAvailable/${propertyId}`, config);
      dispatch({ type: actions.DELETE_PROPERTY });
    } catch (error) {}
  };
};
export const Get_List_Required_Property = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getRequiredRE`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_LIST_PROPERTY_REQUIRED,
          payload: res.data.data,
          require_status: true,
        });
      }
    } catch (error) {}
  };
};

export const Get_List_Required_Property_Rent = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getRequiredPropertyRent`, config);
      dispatch({
        type: actions.GET_LIST_PROPERTY_REQUIRED_RENT,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
// customer Detail
export const Get_List_Customers = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/CustmerRE`, config);
      dispatch({
        type: actions.GET_DETAIL_OF_CUSTOMER,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const View_Customer = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/Custmer/${id}`, config);
      dispatch({
        type: actions.CUSTOMER_VIEWED,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Update_Customer = (id, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };

    try {
      const res = await Instance.put(
        `/api/v1/Custmer/${id}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CISTOMER_UPDATED,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Customer_Delete = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/Custmer/${id}`, config);
      dispatch({ type: actions.CUSTOMER_DELETED, id: id });
    } catch (error) {}
  };
};
